module.exports = __webpack_public_path__ + "static/media/template-library.f7ab66d1.svg";